import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import CrisisDataInput from "../../../components/CrisisDataInput/CrisisDataInput";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";

const CreateCrisisData = () => {
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Crisis data",
      route: "/website/cms/crisis-page/Crisis-data",
    },
    {
      title: "Add Crisis data",
      route: "/website/cms/crisis-page/Crisis-data/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={"Crisis data"}>
      <CustomHeaderTitle title={"Create Crisis data"} />
      <HeaderBread
        navigation={navigation}
        title={"Add Crisis data"}
      ></HeaderBread>
      <CrisisDataInput crisisdata={{}} />
    </Layout>
  );
};

export default CreateCrisisData;
